<template>
  <div>
    <div class="d-flex mt-8 mx-9">
      <div class="d-flex justify-space-between align-center w-100-porcento">
        <div>
          <h2 style="color: #0D0D0E">Rodadas de compras</h2>
          <p class="mt-2">Gerencie as suas rodadas de compras cadastradas para o produto e(ou) fornecedor
            selecionado.</p>
        </div>
        <div>
          <v-btn
            color="#FFFFFF"
            class="vbtn-class bra-6"
            height="40"
            outlined
            @click="criarNovaRodada"
          >
            Adicionar Rodada
          </v-btn>
        </div>
      </div>
    </div>

    <div
      class="mx-9 py-1 mt-6 bra-6 overflow-x-hidden"
      style="max-height: calc(100vh - 383px); overflow-y: auto"
    >
      <div v-if="rodadas_compra && rodadas_compra.length">
        <v-row dense>
          <v-col
            v-for="(rodada, index) in rodadas_compra"
            :key="rodada.id || index"
            cols="12"
          >
            <v-card class="pa-4" outlined>
              <div class="d-flex align-center justify-space-between">
                <div>
                  <div class="d-flex align-center">
                    <h2 class="font-weight-medium" style="color: #0D0D0E">#{{ rodada.id }} - {{ rodada.nome }}</h2>

                    <ProdutosRodadaCompraBadge
                      :produtos="rodada.produtos"
                      :produto_inicial="produto_inicial"
                      :limite="5"
                      titulo="Produtos da Rodada"
                    />
                  </div>

                  <div class="mt-2 text-body-2" style="color:#19191C">
                    Comprar em <b>{{ formatarDataMesAno(rodada.data_inicio_aplicacao) }}</b> -
                    <b>{{ formatarDataMesAno(rodada.data_fim_aplicacao) }}</b>
                    com base nas vendas de <b>{{ formatarDataMesAno(rodada.data_inicio_referencia) }}</b> -
                    <b>{{ formatarDataMesAno(rodada.data_fim_referencia) }}</b>
                  </div>

                  <div class="d-flex align-center mt-4 font-14 text-gray-300" style="">
                    <v-icon class="mr-1" size="18">$Clock</v-icon>
                    {{ rodada.created_at.slice(0, 16) }}
                  </div>
                </div>

                <div class="d-flex">
                  <v-btn
                    class="mr-10"
                    alt="trash.btn"
                    icon
                    @click="excluirRodadaCompra(rodada.id)"
                  >
                    <v-icon color="#4075FF">$Trash</v-icon>
                  </v-btn>

                  <v-btn
                    class="mr-10"
                    alt="pencil-simple.btn"
                    icon
                    @click="editarRodadaCompra(rodada)"
                  >
                    <v-icon color="#4075FF">$PencilSimple</v-icon>
                  </v-btn>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <div
        class="d-flex justify-center align-center flex-column pl-2"
        v-else
      >
        <v-icon size="80" color="#CFD1D7">$Basket</v-icon>

        <h3 class="my-1 font-weight-medium" style="color: #19191C">
          Nenhuma rodada criada
        </h3>
        <p style="color: #73787F">
          Adicione ao menos uma rodada para continuar
        </p>
        <div>
          <v-btn
            color="#FFFFFF"
            class="vbtn-class bra-6"
            height="40"
            outlined
            @click="criarNovaRodada"
          >
            Adicionar Rodada
          </v-btn>
        </div>
      </div>
    </div>

    <DialogExcluirRodadaCompra
      v-model="dialog_excluir_rodada"
      :id_rodada="id_rodada_acao"
      @confirmar="() => rodadas_compra.pop()"
      @fechar="dialog_excluir_rodada = false;"
    />
  </div>
</template>

<script setup>
import { onMounted, reactive, ref } from "vue";
import api from "@/api/api";

import DialogExcluirRodadaCompra
  from "@/components/produto/detalhes/ProjecaoVenda/Parametrizacao/AplicacaoTipoProjecao/CompraSazonal/components/dialog/DialogExcluirRodadaCompra.vue";
import ProdutosRodadaCompraBadge
  from "@/components/produto/detalhes/ProjecaoVenda/Parametrizacao/AplicacaoTipoProjecao/CompraSazonal/components/badge/ProdutosRodadaCompraBadge.vue";
import moment from "moment";

const emit = defineEmits([
  'atualizar:rodada-compra',
  'editar:rodada-compra',
  'criar:rodada-compra'
]);

onMounted(() => {
  buscarRodadasCompras();
});

const dialog_excluir_rodada = ref(false);
const id_rodada_acao = ref(0);

const mensagem_erro = ref('');
const rodadas_compra = ref([]);

const props = defineProps({
  produto_inicial: { type: Object, required: true },
  produtos_selecionados: {
    type: Array,
    required: true
  },
});

const formInicial = () => ({
  nome: '',
  data_inicio_referencia: '',
  data_fim_referencia: '',
  data_inicio_aplicacao: '',
  data_fim_aplicacao: '',
});

const form = reactive(formInicial());

function formatarDataMesAno(data) {
  if (!data || typeof data !== "string") return "";

  const meses = [
    "Jan", "Fev", "Mar", "Abr", "Mai", "Jun",
    "Jul", "Ago", "Set", "Out", "Nov", "Dez"
  ];

  let yyyy, mm;

  let m = data.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (m) {
    yyyy = m[1];
    mm = m[2];
  } else {
    m = data.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (!m) return "";
    yyyy = m[3];
    mm = m[2];
  }

  const mesNum = Number(mm);
  if (!Number.isInteger(mesNum) || mesNum < 1 || mesNum > 12) return "";

  return `${meses[mesNum - 1]}/${yyyy}`;
}

function buscarRodadasCompras() {
  mensagem_erro.value = null;

  const params = {
    id_produto: String(props.produto_inicial.id_produto),
    id_fornecedor: props.produto_inicial.idfornecedor
  }

  api.get('eventos-sazonais/compra-sazonal/buscar-rodadas-compras-existentes', { params })
  .then((response) => {
    if (response.data.length > 0)
      rodadas_compra.value = response.data;
  })
  .catch();
}

const criarNovaRodada = () => {
  emit('criar:rodada-compra', {});
};

const editarRodadaCompra = (rodada) => {
  emit('editar:rodada-compra', rodada);
};

const excluirRodadaCompra = (id) => {
  dialog_excluir_rodada.value = true;
  id_rodada_acao.value = id;
};
</script>

<style scoped>
.vbtn-class {
  text-transform: none;
  background-color: #4075FF;
  border: 1px solid #4075FF;
  padding: 15px 35px 15px 35px;
  margin-top: 1px;
  font-weight: 500;
}
</style>
